<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="newCritereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless hauteur-brief-filtre">
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeCommandeTlpe.filtre.code')">
          <qd-taginput v-model="newCritereRecherche.codes"
                      type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeCommandeTlpe.filtre.annee')">
          <b-select v-model="newCritereRecherche.annee">
            <option v-for="year in getYearRange"
                    :key="year"
                    :value="year">
              {{year}}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeCommandeTlpe.filtre.declarant')">
          <qd-taginput v-if="declarantTags"
                      v-model="declarantSelected"
                      :data="declarantTags"
                      icon="magnify"
                      type="is-primary"
                      autocomplete
                      open-on-focus
                      field="decorator.nomPrenom"
                      @typing="getFilteredDeclarantTags"
                      @input="getDeclarantTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeCommandeTlpe.filtre.collectivite')">
          <qd-taginput
            v-model="collectiviteSelected"
            icon="magnify"
            :data="collectivites"
            autocomplete
            type="is-primary"
            :loading="isFetchingCollectivite"
            field="nomCommercial"
            @typing="getCollectivite">
            <template slot-scope="props">
              {{ props.option.nomCommercial }}
            </template>
            <template slot="empty">
              <div v-if="!isFetchingCollectivite"> {{ $t('general.autocomplete.noRslt') }} </div>
              <div v-else> {{ $t('general.autocomplete.search') }} </div>
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                      :label="$t('listeCommandeTlpe.filtre.etat')"
                      :items="constantes.DEVIS_COMMANDE_ETAT"
                      v-model="etatsSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                      :label="$t('listeCommandeTlpe.filtre.typeDeclaration')"
                      :items="constantes.LISTE_TYPE_DECLARATION"
                      v-model="typeDeclaSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeCommandeTlpe.filtre.codeDossier')">
          <qd-taginput v-model="newCritereRecherche.codesDossier"
                      type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeCommandeTlpe.filtre.departement')">
          <qd-taginput v-model="newCritereRecherche.tiersDepartement"
                    type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('listeOrdreTravailAffichage.filtre.actions.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('listeOrdreTravailAffichage.filtre.actions.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import debounce from 'lodash/debounce';
import { DEVIS_COMMANDE_ETAT } from '@/configuration/devisConf';
import { TIERS_TYPE_FOURNISSEUR, TIERS_SOUS_TYPE_COLLECTIVITE } from '@/configuration/tiers/tiersConf';
import { getAll } from '@/api/tiers';
import { SET_CRITERE_RECHERCHE } from '@/store/modules/gabed/commandeTlpe-mutation-type';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import genererCritereRecherche
  from '@/services/gabed/commandeTlpe/genererCritereRechercheCommanndeTlpe';
import messageErreur from '@/services/general/messageErreur';
import { LISTE_TYPE_DECLARATION } from '@/configuration/gabed/tlpe/tlpeConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';

const CommandeTlpe = createNamespacedHelpers('commandeTlpe');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      newCritereRecherche: null,
      constantes: {
        DEVIS_COMMANDE_ETAT,
        LISTE_TYPE_DECLARATION,
      },
      etatsSelected: [],
      typeDeclaSelected: [],
      isFetchingCollectivite: false,
      collectivites: [],
      collectiviteSelected: [],
      listeDeclarant: [],
      declarantSelected: [],
      declarantTags: null,
    };
  },
  components: {
    libelleTagInput,
  },
  computed: {
    ...CommandeTlpe.mapGetters({
      critereRechercheFromStore: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    getYearRange() {
      const baseYear = this.newCritereRecherche.annee
        ? cloneDeep(this.newCritereRecherche.annee) : moment().year();
      const years = [];
      for (let i = 5; i !== 0; i -= 1) years.push(baseYear - i);
      years.push(baseYear);
      for (let i = 1; i < 3; i += 1) years.push(baseYear + i);
      return years;
    },
  },
  methods: {
    ...CommandeTlpe.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE,
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    async collectivitesInfo(text, ids = []) {
      try {
        this.collectivites = [];
        if (!text && ids.length === 0) return;
        this.isFetchingCollectivite = true;
        const query = {
          societeId: this.societeActiveId,
          type: TIERS_TYPE_FOURNISSEUR,
          sousType: [TIERS_SOUS_TYPE_COLLECTIVITE],
          archive: false,
        };
        if (ids.length > 0) {
          query.tiersId = ids;
        }
        if (text) {
          query.auto = text;
        }
        const collectivites = (await getAll({
          query,
          limit: NO_PAGINATION,
        })).data.result.items;
        this.collectivites = collectivites.filter((collectivite) => {
          return !this.collectiviteSelected.map(
            collectiviteSelect => collectiviteSelect.id,
          ).includes(collectivite.id);
        });
        this.isFetchingCollectivite = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingCollectivite = false;
        throw e;
      }
    },
    getCollectivite: debounce(async function collectiviteData(text) {
      await this.collectivitesInfo(text);
    }, 500),
    appliquerCritere() {
      this.newCritereRecherche.etat = this.etatsSelected.map(el => { return el.code; });
      this.newCritereRecherche.typesDeclaration = this.typeDeclaSelected
        .map(el => { return el.code; });
      this.newCritereRecherche.tiersId = this.collectiviteSelected.map(el => { return el.id; });
      this.newCritereRecherche.commercialId = this.declarantSelected.map((d) => {
        return d.id;
      });
      this.setCritereRecherche(this.newCritereRecherche);
      this.$emit('recherche');
    },
    viderCritere() {
      this.etatsSelected = [];
      this.typeDeclaSelected = [];
      this.collectiviteSelected = [];
      this.declarantSelected = [];
      this.getDeclarantTag();
      this.newCritereRecherche = genererCritereRecherche();
    },
    getDeclarantTag() {
      this.declarantTags = this.listeDeclarant.filter((d) => {
        return !this.declarantSelected.map(decla => decla.id).includes(d.id);
      });
    },
    getFilteredDeclarantTags(text) {
      this.getDeclarantTag();
      this.declarantTags = this.declarantTags.filter((declarant) => {
        return declarant.decorator.nomPrenom.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametreUtilisateur();
        this.newCritereRecherche = cloneDeep(this.critereRechercheFromStore);
        if (this.newCritereRecherche.tiersId.length > 0) {
          await this.collectivitesInfo(null, this.newCritereRecherche.tiersId);
        }
        this.newCritereRecherche.tiersId.forEach((id) => {
          const collectiviteFind = this.collectivites.find((c) => {
            return c.id === id;
          });
          if (collectiviteFind) this.collectiviteSelected.push(collectiviteFind);
        });
        if (this.newCritereRecherche.etat.length > 0) {
          this.etatsSelected = this.constantes.DEVIS_COMMANDE_ETAT.filter((e) => {
            return this.newCritereRecherche.etat.includes(e.code);
          });
        }
        if (this.newCritereRecherche.typesDeclaration.length > 0) {
          this.typeDeclaSelected = this.constantes.LISTE_TYPE_DECLARATION.filter((e) => {
            return this.newCritereRecherche.typesDeclaration.includes(e.code);
          });
        }
        this.listeDeclarant = this.parametre(PARAMETRES_KEYS.utilisateur)
          .filter(u => u.actif);
        this.declarantSelected = this.listeDeclarant.filter((d) => {
          return this.newCritereRecherche.commercialId.includes(d.id);
        });
        this.getDeclarantTag();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};

</script>
